module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ecDeal"
  }, [_c('banner', {
    attrs: {
      "clazz": "ecDeal-banner",
      "url": "ecdeal"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('dianshancuohe-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")])], 1)], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ecDeal-section2"
  }, [_c('div', {
    staticClass: "item-list"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-tab"
  }, [_c('el-tabs', {
    staticClass: "ecDeal-tab",
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "非生产物资的管控难点"
    }
  }, [_c('div', {
    staticClass: "rel clearfix content"
  }, [_c('div', {
    staticClass: "fl rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/ecDeal/nandian1.png"),
      "alt": "非生产物资的管控难点"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg01"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl left-list"
  }, [_c('div', {
    staticClass: "left-desc"
  }, [_c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("采购成本高：价格不透明，缺乏竞争机制，采购相关费用高\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("采购质量差：缺乏统一的供应商评价体系以及定期审查、年审\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("采购协同弱：缺乏有效的企业内外部协同支撑，无法降低整体成本，影响效率\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("采购管控散：原有的采购分散，由于缺乏工具支撑无法整合形成规模化采购\n                  ")])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "甄云解决方案"
    }
  }, [_c('div', {
    staticClass: "rel clearfix content"
  }, [_c('div', {
    staticClass: "fl rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/ecDeal/nandian2.png"),
      "alt": "甄云解决方案"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg01"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("甄云采购商城整合间接物资海量供应商， 对接内部系统，给企业带来非常可观的价值。")]), _vm._v(" "), _c('div', {
    staticClass: "left-desc"
  }, [_c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("降低成本：战略寻源，集合海量货源，通过比价，招投标降低采购成本\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("提高效率：建立统一集成的供应商管理管理系统提升内外部效率\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("保证质量：建立供应商全生命周期管理体系，优胜劣汰\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("控制风险：通过IT手段，规范采购业务流程，降低采购风险\n                  ")])])])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ecDeal-section3"
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("为什么选择甄云采购商城？")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "section3-photo clealfix"
  }, _vm._l((_vm.sectionData), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "photo-div",
      style: ({
        'backgroundImage': 'url(' + require('../../assets/img/ecDeal/peitu-' + (index + 1) + '.png') + ')'
      })
    }, [_c('div', {
      staticClass: "photo-div-icon"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.imgtag),
        expression: "$global.globalPath + item.imgtag"
      }],
      attrs: {
        "alt": "为什么选择甄云采购商城"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "photo-div-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "photo-div-con tl"
    }, [_c('p', [_vm._v(_vm._s(item.describe))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ecDeal-section4"
  }, [_c('div', {
    staticClass: "section4-content"
  }, [_c('h1', {
    staticClass: "section4-title"
  }, [_vm._v("成功客户案例")]), _vm._v(" "), _c('div', {
    staticClass: "section4-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-photo clearfix"
  }, _vm._l((_vm.imgData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "section4-photo-div"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.dians_logo),
        expression: "$global.globalPath + item.dians_logo"
      }],
      attrs: {
        "alt": "成功客户案例"
      }
    })])
  }), 0), _vm._v(" "), _c('hover-button', {
    attrs: {
      "clazz": "consult-button",
      "text": "获取案例详情"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMoreCase.apply(null, arguments)
      }
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ecDeal-section1"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('h1', {
    staticClass: "section1-title"
  }, [_vm._v("为SRM平台客户与供应商建立交易及撮合平台")]), _vm._v(" "), _c('div', {
    staticClass: "section1-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ecDeal-intro"
  }, [_c('p', [_vm._v("甄云商城连接了多个外部采购平台（自有供应商和第三方电商平台），采购方通过一个商城平台，可获取海量商品选择，择优采购，实现企业采购集中化管理和一站式信息化采购流程。")])]), _vm._v(" "), _c('div', {
    staticClass: "section1-photo"
  }, [_c('img', {
    staticClass: "photo-img",
    attrs: {
      "src": require("../../assets/img/ecDeal/img.png"),
      "alt": "为SRM平台客户与供应商建立交易及撮合平台"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "item-list-title"
  }, [_vm._v("甄云采购商城解决的难点")]), _vm._v(" "), _c('div', {
    staticClass: "dib tl border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ecDeal-intro"
  }, [_c('p', [_vm._v("从客户需求出发，结合数字化技术，简化企业采购流程，提供高质海量供应货源")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345a0050"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ecDeal.vue
// module id = 549
// module chunks = 12